<template>
  <div
    v-if="product.socialSelling && isAvailable && getSvg"
    class="social-selling"
  >
    <span class="icon" v-html="getSvg" />
    <span
      class="text-mobile-paragraph-s-medium text-desktop-paragraph-s-medium"
      v-html="product.socialSelling.description"
    />
  </div>
</template>

<script>
/**
 * Vue: social selling (social-selling)
 * -----------------------------------------------------------------------------
 * Show customers recently bought count of other customers.
 * - Component settings: snippet / dynamic / async / scroll
 *
 */
import { formatSvg } from '~/core/helpers/format-richtext';

export default {
  name: 'SocialSelling',

  props: {
    product: {
      type: Object,
      required: true,
    },
  },

  computed: {
    isAvailable() {
      return (
        !['back-soon', 'sold-out'].includes(this.product.availableState) &&
        this.product.available
      );
    },

    /**
     * Get SVG code from image url via request.
     * - If the image is not SVG, return false.
     */
    getSvg() {
      try {
        if (!this.product.socialSelling.icon.includes('.svg')) {
          return false;
        }
        const svgCode = formatSvg(this.product.socialSelling.icon);
        return svgCode;
      } catch (error) {
        return false;
      }
    },
  },
};
</script>

<style lang="scss">
@import './social-selling';
</style>
